import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetChatSettingsKnowledge as GetChatSettingsKnowledgeQuery,
    ChatSettingsKnowledgeFragment,
} from 'nutshell-graphql-types';

import GET_CHAT_SETTINGS_KNOWLEDGE_OPTIONS from '../queries/get-chat-settings-knowledge.graphql';

export const useGetChatSettingsKnowledge = (): {
    chatSettings: ChatSettingsKnowledgeFragment | null | undefined;
    error: string | null | undefined;
    isLoading: boolean;
    refetch: () => Promise<any>;
} => {
    const {data, error, loading, refetch} = useQuery<
        GetChatSettingsKnowledgeQuery,
        Record<any, any>
    >(GET_CHAT_SETTINGS_KNOWLEDGE_OPTIONS, {});

    const chatSettings = data ? data.chatSettings : null;

    return {
        chatSettings,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        isLoading: loading,
        refetch,
    };
};
